var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sp-loader",class:{
        'sp-loader--overlay': _vm.overlay,
        'sp-loader--compact': _vm.compact,
    },attrs:{"aria-busy":true,"aria-label":_vm.label || 'Загрузка'}},[_c('SpinnerLoader'),(_vm.label)?_c('span',{staticClass:"sp-loader__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }